import { _parseDateFR } from '../../lib/dates';

/** Jour depuis lequel SwissTech note la date d'envoi de chaque facture. */
const SUIVI_DES_ENVOIS = new Date(2026, 9, 7);

/**
 * Facture émise mais pas encore partie chez le client. « Émettre & envoyer »
 * numérote la facture avant d'ouvrir la fenêtre d'envoi ; refermée sans rien
 * envoyer, la facture se disait « Envoyée ». Les factures d'avant le suivi
 * des envois n'ont pas de date d'envoi : elles gardent leur statut.
 *
 * @param {object} f la facture
 * @returns {boolean} vrai tant qu'elle reste à envoyer
 */
export function pasEncoreEnvoyee(f) {
  if (f?.statut !== 'Envoyée' || f.envoyeLe || f.vuLe) return false;
  const emise = _parseDateFR(f.date);
  return Boolean(emise) && emise >= SUIVI_DES_ENVOIS;
}
